// tinyapp
import tinyapp_singleUrlPage from "../images/tinyapp/single-url-page.png";
import tinyapp_urlsPage from "../images/tinyapp/urls-page.png";
import tinyapp_createNewUrlPage from "../images/tinyapp/create-new-url-page.png";
import tinyapp_loginPage from "../images/tinyapp/login-page.png";
import tinyapp_urlsPageBeforeLogin from "../images/tinyapp/urls-page-before-login.png";

// tweeter
import tweeter_mainPageDesktop from "../images/tweeter/main-page-desktop.png";
import tweeter_mainPageMobile from "../images/tweeter/main-page-mobile.png";
import tweeter_scrollToTopButton from "../images/tweeter/scroll-to-top-button.png";
import tweeter_characterCounter from "../images/tweeter/character-counter.png";
import tweeter_createTweetMobile from "../images/tweeter/create-tweet-mobile.png";
import tweeter_errorIfTextIsTooLong from "../images/tweeter/error_if_text_is_too_long.png";
import tweeter_protectAgainstXSS from "../images/tweeter/tweeter_protectAgainstXSS.png";

// scheduler
import scheduler_displayingAppointments from "../images/scheduler/1-displaying_appointments.png";
import scheduler_addingNewAppointments from "../images/scheduler/2-adding_new_appointments.png";
import scheduler_confirmDeleteAppointment from "../images/scheduler/3-confirm_delete_appointment.png";
import scheduler_mobileView from "../images/scheduler/4-mobile_view.png";

// food-pickup-ordering
import fpo_inputDetails from "../images/food-pickup-ordering/fpo_inputDetails.png";
import fpo_mobileSidebar from "../images/food-pickup-ordering/fpo_mobileSidebar.png";
import fpo_mobileView from "../images/food-pickup-ordering/fpo_mobileView.png";
import fpo_ordersMain from "../images/food-pickup-ordering/fpo_ordersMain.png";
import fpo_restaurantComplete from "../images/food-pickup-ordering/fpo_restaurantComplete.png";
import fpo_restaurantPending from "../images/food-pickup-ordering/fpo_restaurantPending.png";
import fpo_restaurantTimeUp from "../images/food-pickup-ordering/fpo_restaurantTimeUp.png";
import fpo_restaurantView from "../images/food-pickup-ordering/fpo_restaurantView.png";

// jungle
import jungle_adminAuthentication from "../images/jungle/admin_authentication.png";
import jungle_adminCategories from "../images/jungle/admin_categories.png";
import jungle_adminDashboard from "../images/jungle/admin_dashboard.png";
import jungle_createNewSale from "../images/jungle/create_new_sale.png";
import jungle_email from "../images/jungle/email.png";
import jungle_reviews from "../images/jungle/reviews.png";
import jungle_salesDashboard from "../images/jungle/sales_dashboard.png";
import jungle_showCurrentSale from "../images/jungle/show_current_sale.png";
import jungle_soldOutBadge from "../images/jungle/sold_out_badge.png";

// your-tube
import yourTube_addToNewPlaylist from '../images/your-tube/yourTube_addToNewPlaylist.png';
import yourTube_homePage from '../images/your-tube/yourTube_homePage.png';
import yourTube_playlistSidebar from '../images/your-tube/yourTube_playlistSidebar.png';
import yourTube_searchResults from '../images/your-tube/yourTube_searchResults.png';
import yourTube_videoPageAudioMode from '../images/your-tube/yourTube_videoPageAudioMode.png';
import yourTube_videoPageDownloads from '../images/your-tube/yourTube_videoPageDownloads.png';
import yourTube_videoPageInvidiousVideo from '../images/your-tube/yourTube_videoPageInvidiousVideo.png';
import yourTube_videoPageInvidiousVideoBottom from '../images/your-tube/yourTube_videoPageInvidiousVideoBottom.png';
import yourTube_videoPagePlaylistView from '../images/your-tube/yourTube_videoPagePlaylistView.png';
import yourTube_videoPageYoutube from '../images/your-tube/yourTube_videoPageYoutube.png';


export const images = {
  tinyapp_singleUrlPage,
  tinyapp_urlsPage,
  tinyapp_createNewUrlPage,
  tinyapp_loginPage,
  tinyapp_urlsPageBeforeLogin,
  tweeter_mainPageDesktop,
  tweeter_mainPageMobile,
  tweeter_scrollToTopButton,
  tweeter_characterCounter,
  tweeter_createTweetMobile,
  tweeter_errorIfTextIsTooLong,
  tweeter_protectAgainstXSS,
  scheduler_addingNewAppointments,
  scheduler_confirmDeleteAppointment,
  scheduler_displayingAppointments,
  scheduler_mobileView,
  fpo_inputDetails,
  fpo_mobileSidebar,
  fpo_mobileView,
  fpo_ordersMain,
  fpo_restaurantComplete,
  fpo_restaurantPending,
  fpo_restaurantTimeUp,
  fpo_restaurantView,
  jungle_adminAuthentication,
  jungle_adminCategories,
  jungle_adminDashboard,
  jungle_createNewSale,
  jungle_email,
  jungle_reviews,
  jungle_salesDashboard,
  jungle_showCurrentSale,
  jungle_soldOutBadge,
  yourTube_addToNewPlaylist,
  yourTube_homePage,
  yourTube_playlistSidebar,
  yourTube_searchResults,
  yourTube_videoPageAudioMode,
  yourTube_videoPageDownloads,
  yourTube_videoPageInvidiousVideo,
  yourTube_videoPageInvidiousVideoBottom,
  yourTube_videoPagePlaylistView,
  yourTube_videoPageYoutube
};
